import {
  labelFromOtherStored,
  OTHER_VALUE_PREFIX
} from '../components/CustomInputs/Select/SelectWithOtherOption';
import {ISelect} from '../interface/ISelect';

const mapAndFilter = (
  data: any,
  JSON: ISelect[],
  key: string,
  mapWithKey?: 'label' | 'value',
  mayHasOtherOption: boolean = false
): ISelect[] => {
  const mappedAndFilteredCountries: any = [];
  const processedCountryCodes = new Set();

  data?.forEach((item: any) => {
    const raw = item?.[key];
    const country = JSON.find((c) =>
      mapWithKey ? c[mapWithKey] === raw : c?.value === raw
    );

    if (country && !processedCountryCodes.has(country.value)) {
      const {value, label} = country;
      mappedAndFilteredCountries.push({
        value,
        label
      });
      processedCountryCodes.add(country.value);
    } else if (
      mayHasOtherOption &&
      typeof raw === 'string' &&
      raw.startsWith(OTHER_VALUE_PREFIX) &&
      !processedCountryCodes.has(raw)
    ) {
      mappedAndFilteredCountries.push({
        value: raw,
        label: labelFromOtherStored(raw)
      });
      processedCountryCodes.add(raw);
    }
  });

  return mappedAndFilteredCountries;
};

export default mapAndFilter;
